module.exports = __webpack_public_path__ + "static/media/building.760a3b40.svg";